export default {
    'signin.title': 'Sign in to your patient portal',
    'signin.phone': 'Mobile number',
    'signin.send_code': 'Send me a code',
    'signin.code': 'Code',
    'signin.verify': 'Sign in',
    'home.appointments': 'My appointments',
    'home.reports': 'My reports',
    'home.bills': 'My bills',
    'bills.due': 'Amount due',
    'bills.pay': 'Pay now',
    'kiosk.title': 'Check in for your appointment',
    'kiosk.identifier': 'Your MRN or mobile number',
    'kiosk.check_in': 'Check in',
    'kiosk.done': 'You are checked in. Your token is {token}.',
    'kiosk.not_found': 'We could not find a booking for today. Please see the front desk.',
    'signin.heading': 'My health record',
    'signin.hint': 'Sign in with the mobile number the hospital has on file.',
    'signin.code_six': 'Six-digit code',
    'signin.code_hint': 'We sent it by SMS. It expires in ten minutes.',
    'signin.choose_patient': 'More than one patient uses this mobile number. Choose whose record to open, and confirm their date of birth.',
    'signin.date_of_birth': 'Date of birth',
    'signin.change_number': 'Change number',
    'kiosk.checked_in': 'Checked in, {name}',
    'kiosk.your_token': 'Your token',
    'kiosk.wait_for': 'Please wait for {doctor} to call you.',
    'kiosk.hint': 'Enter your MRN or the mobile number you registered with.',
    'kiosk.dob_hint': 'Date of birth (needed if family members share your mobile number)',
    'tele.title': 'Video consultation',
    'tele.invalid_link': 'That link is not valid. Ask the hospital to send it again.',
    'tele.consultation_ended': 'This consultation has ended.',
    'tele.call_ended': 'The call has ended.',
    'tele.join_hint_patient': 'Join when you are ready. Your doctor will see that you have arrived.',
    'tele.join_hint_doctor': 'Join to start the consultation.',
    'tele.doctor_present': 'Your doctor is already in the room.',
    'tele.patient_present': 'The patient is already waiting.',
    'tele.join_now': 'Join now',
    'tele.doctor_sign_in': 'Sign in to the hospital first, then open this link again to join as the doctor.',
    'tele.doctor_refused': 'Only the doctor of this consultation or a covering doctor can join as the doctor. Sign in again and retry.',
    'tele.provider_pending': 'The video window opens here once the hospital’s video provider is configured ({provider}).',
    'tele.media_error': 'Could not access your camera or microphone. Allow access and reload.',
    'tele.waiting_for_doctor': 'Waiting for your doctor to join…',
    'tele.waiting_for_patient': 'Waiting for the patient to join…',
    'tele.connecting': 'Connecting…',
    'tele.connected': 'Connected',
    'tele.reconnecting': 'Reconnecting…',
    'tele.quality_good': 'Good',
    'tele.quality_fair': 'Fair',
    'tele.quality_poor': 'Poor',
    'tele.mute_microphone': 'Mute microphone',
    'tele.turn_camera_off': 'Turn camera off',
    'tele.end_call': 'End call',
    'tele.error': 'Something went wrong. Please try again.',
    'screen.find_care': 'Find care',
    'screen.my_record': 'My health record',
    'section.when': 'When',
    'section.who': 'Who is coming',
    'section.order': 'Your order',
    'section.delivery': 'Delivery',
    'section.payment': 'Payment',
    'checkout.proof_label': 'Transfer slip',
    'checkout.proof_hint': 'A photo or PDF of the transfer, up to 5 MB',
    'checkout.proof_choose': 'Choose a file',
    'checkout.proof_replace': 'Choose another file',
    'checkout.proof_uploading': 'Uploading…',
    'checkout.proof_attached': 'Attached: {name}',
    'checkout.proof_wrong_type': 'Use a PDF, JPEG, PNG or WebP file',
    'checkout.proof_too_big': 'That file is larger than 5 MB',
    'checkout.proof_failed': 'The slip could not be uploaded. Try again.',
    'section.person': 'About them',
    'section.doctor': 'Doctor',
    'section.time': 'Pick a time',
    'section.details': 'Details',
};
//# sourceMappingURL=portal.js.map